import template from './faq-list.html';
import controller from './faq-list.controller';
import './faq-list.scss';

let faqListComponent = {
  bindings: {},
  template,
  controller
};

export default faqListComponent;


// WEBPACK FOOTER //
// ./client/app/components/faq/faq-list.component.js